import ListItem from '@lib/components/ListItem';
import TitleBar, * as ITitleBar from '@lib/components/TitleBar';
import { UserProps } from '@lib/containers/User';
import * as React from 'react';
import { IUser } from 'types';
import './User.css';

declare var Waves: any;

class User extends React.Component<UserProps, object> {

  public constructor(props: UserProps) {
    super(props);
  }

  public componentDidMount() {
    Waves.attach('div.listItem', 'waves-light');
  }

  /**
   * Fired when user clicks on an item 
   * @param state 
   * @param event 
   */
  public onItemClick(item: string, event: React.MouseEvent<HTMLDivElement>) {
    event.stopPropagation();
  }


  /**
   * Fired when user click on menu hamburger button
   * @param event 
   */
  public onMenuClick(event: React.MouseEvent<HTMLDivElement>) {
    this.props.onGoBack();
  }



  public render() {

    if (this.props.user === undefined || this.props.user === null) {
      window.location.pathname = '/';
      window.location.hash = '';
      return null;
    }

    const i18n = this.props.i18n.User;

    return (
      <div className="standardPage">

        <TitleBar
          leftIcon={ITitleBar.ICO_CHEVRON_LEFT}
          onLeftButtonClick={this.onMenuClick.bind(this, this.state)}
          title={i18n.title}
        />
        <div id="userList">
          {this.props.user.map((user: IUser) => (
            <ListItem leftIcoClass='none' icoClass='none'
              title={user.email}
              detail={this.props.i18n.User.lastConnection + ' ' + user.lastConnection.toLocaleString('fr-FR', { timeZone: "Europe/Paris" })}
              notif={0} key={user.email} onClick={this.onItemClick.bind(this, user)} />
          ))}
        </div>
      </div>
    );
  }
}

export default User;



// WEBPACK FOOTER //
// ./src/pages/User.tsx